import { render } from "./CustomerSpecialPricing.html?vue&type=template&id=ed7c9abe&scoped=true"
import script from "./CustomerSpecialPricing.js?vue&type=script&lang=js"
export * from "./CustomerSpecialPricing.js?vue&type=script&lang=js"

import "./CustomerSpecialPricing.css?vue&type=style&index=0&id=ed7c9abe&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed7c9abe"]])

export default __exports__